<template>
  <div>
    <p>Subscription</p>
    <p>Sub ID: {{ subId }}</p>
  </div>
</template>

<script>
export default {
  props: ['subId']
}
</script>

